import React from 'react';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import CreateMcpModal from '@/components/modal/create-wcp';
import userStore from '@/store/user';
import InviteCodeModal from '@/components/modal/invite-code';
import { Tooltip } from 'antd';
import globalStore from '@/store/global';
import agentPageStore from '../store';


const InviteUseBtn = observer(({ className }) => {
  useEffect(() => {
    return () => {
      CreateMcpModal.close();
      InviteCodeModal?.close?.();
    };
  }, []);
  return (
    userStore.isUser 
    ? (
      <Tooltip title="为好友助力，免费获得限免智能体（超级搜索）使用次数">
        <div 
          className={`h-32px rounded-full flex items-center box-border border-1px border-solid border-[rgba(0,0,0,0.16)] px-12px gap-6px mr-10px hover:bg-[rgba(0,0,0,0.03)] cursor-pointer ${className}`}
          onClick={() => {
            InviteCodeModal.show({callback: () => {
              setTimeout(() => {
                globalStore.getInviteStaus();
                agentPageStore.updateChatLimit();
              }, 1000);
            }})
          }}
        >
          <img
            src="https://p0.ssl.qhimg.com/t110b9a9301eb3e95d581c9b431.png"
            className='w-14px h-15px'
          />
          <div>输入助力码</div>
        </div>
      </Tooltip>
    )
    : null)
})

export default InviteUseBtn;